import { NavLink, Outlet } from "react-router-dom";

const tabs = [
  {
    label: "Job Matches",
    route: "job-matches",
  },
  {
    label: "Applied Jobs",
    route: "job-track",
  },
  {
    label: "Applied Job Details Static",
    route: "/applied-job-details-new",
  },
];

const JobPageLayout = () => {
  return (
    <div className="flex flex-col flex-1 rounded-md bg-white p-6">
      {/* Tabs container */}
      <div className="flex items-center border-b w-full pb-2 gap-10">
        {tabs?.map((tab, tabIndex) => {
          return (
            <NavLink
              key={tab?.label}
              to={tabIndex === 2 ? tab?.route:`/job/${tab?.route}`}
              className={({ isActive }) =>
                `font-semibold text-xs ${
                  isActive
                    ? "text-charcoal border-b border-primary"
                    : "text-light-grey"
                }  pb-0.5`
              }
            >
              {tab?.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
};

export default JobPageLayout;
